export default __webpack_public_path__ + "static/media/andes_a_la_costa_8.4c2fe24c.JPG";